import dayjs from 'dayjs';
import { assign } from '@atds-legacy/lang';
import { Record, SDK } from '@redge-media/fo-js-sdk';

const Time = Record.extend({
  method: 'get',

  constructor: function Time(info) {
    Record.call(assign(this, {
      info,
    }));

    this.clientTimeOffset = 0;

    this.info.on('sync', this.synchronize, this);
  },

  get now() {
    return dayjs().add(this.clientTimeOffset, 'ms');
  },

  synchronize() {
    return SDK.apiAdapter.get('/time')
      .then((response) => {
        this.clientTimeOffset = -dayjs().diff(response.data, 'ms');
        this.emit('sync', this.method, this);
      });
  },

  isNowBetweenDates(item) {
    const now = dayjs(this.now);
    const since = dayjs(item.since);

    if (item.till) {
      const till = dayjs(item.till);
      return now.isBetween(since, till);
    }

    return now.isAfter(since);
  },

  isFutureDate(item) {
    const now = dayjs(this.now);
    const since = dayjs(item.since);

    return since.isAfter(now);
  },
});

export default Time;
